import type { ReactNode, CSSProperties } from 'react';

interface GabCardProps {
  children: ReactNode;
  className?: string;
  bordered?: boolean;
  accentColor?: string;
  style?: CSSProperties;
  onClick?: () => void;
}

export function GabCard({ children, className = '', bordered, accentColor, style, onClick }: GabCardProps) {
  const cls = ['card', bordered ? 'card-bordered' : '', className].filter(Boolean).join(' ');
  const s: CSSProperties = { ...style };
  if (accentColor) s.borderTop = `3px solid ${accentColor}`;
  if (onClick) s.cursor = 'pointer';
  return <div className={cls} style={s} onClick={onClick}>{children}</div>;
}

export function GabCardHeader({ children, className = '' }: { children: ReactNode; className?: string }) {
  return <div className={`card-header ${className}`}>{children}</div>;
}

export function GabCardBody({ children, className = '' }: { children: ReactNode; className?: string }) {
  return <div className={`card-body ${className}`}>{children}</div>;
}

export function GabCardFooter({ children, className = '' }: { children: ReactNode; className?: string }) {
  return <div className={`card-footer ${className}`}>{children}</div>;
}

interface GabStatCardProps {
  label: string;
  value: string | number;
  description?: string;
  icon?: ReactNode;
  iconColor?: 'primary' | 'success' | 'warning' | 'error' | 'info';
  compact?: boolean;
  accentColor?: string;
}

export function GabStatCard({ label, value, description, icon, iconColor = 'primary', compact, accentColor }: GabStatCardProps) {
  const cls = ['card-metric', compact ? 'card-metric-compact' : '', icon ? 'card-metric-with-icon' : ''].filter(Boolean).join(' ');
  const s: React.CSSProperties = {};
  if (accentColor) s.borderTop = `3px solid ${accentColor}`;
  return (
    <div className={cls} style={s}>
      <div className="card-metric-content">
        <div className="card-metric-label">{label}</div>
        <div className="card-metric-value">{value}</div>
        {description && <div className="card-metric-description">{description}</div>}
      </div>
      {icon && <div className={`card-metric-icon ${iconColor}`}>{icon}</div>}
    </div>
  );
}
